import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent'
import { Ajax } from '@newrelic/browser-agent/features/ajax'
import { JSErrors } from '@newrelic/browser-agent/features/jserrors'
import { Metrics } from '@newrelic/browser-agent/features/metrics'
import { GenericEvents } from '@newrelic/browser-agent/features/generic_events'
import { SessionTrace } from '@newrelic/browser-agent/features/session_trace'
import { Logging } from '@newrelic/browser-agent/features/logging'
import { Spa } from '@newrelic/browser-agent/features/spa'
import { consola } from 'consola'
import stringify from 'stringify-object'
import { serializeError } from 'serialize-error'

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  if (!['production', 'staging'].includes(config.public.ENVIRONMENT_NAME)) return console.warn('not installing new relic')
  if (!config.public.NEW_RELIC_ENABLED) return console.warn('not installing new relic')

  // Populate using values in copy-paste JavaScript snippet.
  const options = {
    init: {
      session_replay: {
        enabled: true,
        block_selector: '',
        mask_text_selector: '',
        sampling_rate: 10.0,
        error_sampling_rate: 100.0,
        mask_all_inputs: false,
        collect_fonts: true,
        inline_images: false,
        inline_stylesheet: true,
        fix_stylesheets: true,
        mask_input_options: {}
      },
      distributed_tracing: { enabled: true, exclude_newrelic_header: true },
      privacy: { cookies_enabled: true },
      ajax: { deny_list: ['bam.nr-data.net'] },
      logging: { autoStart: false },
      page_view_timing: { enabled: false }
    }, // NREUM.init
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: 'NRJS-12c2cdfa9c69f61c99e',
      applicationID: '601536685',
      sa: 1
    },
    // NREUM.info
    loader_config: {
      accountID: '6456704',
      trustKey: '6456704',
      agentID: '601536685',
      licenseKey: 'NRJS-12c2cdfa9c69f61c99e',
      applicationID: '601536685'
    } // NREUM.loader_config
  }

  // The agent loader code executes immediately on instantiation.
  const agent = new BrowserAgent({
    ...options,
    features: [
      Ajax,
      JSErrors,
      Metrics,
      GenericEvents,
      SessionTrace,
      Spa,
      Logging
    ]
  })
  agent.setApplicationVersion(config.public.ENVIRONMENT_NAME)
  agent.start()
  consola.wrapConsole()
  consola.setReporters([
    {
      log: (msg) => {
        const logLevel = {
          0: 'ERROR',
          1: 'WARN',
          2: 'INFO',
          3: 'INFO',
          4: 'DEBUG'
        }

        agent.log(msg.args.map(x => stringify(serializeError(x))).join(' '), { level: logLevel[msg.level] })
      }
    }
  ])
  return {
    provide: {
      newRelic: agent
    }
  }
})
